import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import VueBus from 'vue-bus';
import resonancePlugin from 'resonance-theme/src/vue/plugin';
import i18n from './lib/i18next';
import auth from './lib/auth';

import './lib/axios';
import './assets/app.scss';
import './lib/cookies';
import './plugins';
import './lib/echo';
import './lib/read-more';
import './lib/components/'; // global layout component registration

const bootstrap = require('bootstrap');

Vue.use(auth);
Vue.use(VueBus);
Vue.use(resonancePlugin, bootstrap);

Vue.config.productionTip = false;

window.vm = new Vue({
  created() {},
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
